import { formatDollar, formatPercent } from '../../../../../helpers/formatters';
import { numberSort } from '../../../../../components/LrGrid';
import { IAggFuncParams, ICellRendererParams, ValueGetterParams } from 'ag-grid-enterprise';
import React from 'react';

export const groupColumnDefs = (isAdmin: boolean) => ({
    defaults: {
        columnDefs: [
            {
                rowGroup: true,
                enableValue: true,
                hide: true,
            },
            {
                field: 'locationName',
                headerName: 'Location',
                aggFunc: (params: IAggFuncParams) => '',
                width: 200,
                cellRenderer: (params: ICellRendererParams) => {
                    return params.node.group || !isAdmin ? (
                        ''
                    ) : (
                        <a
                            href={`/submission/${params.data.submissionId}/location/${params.data.locationId}`}
                            target={'_blank'}
                        >
                            {params.value}
                        </a>
                    );
                },
            },
            {
                headerName: 'Address',
                enableValue: true,
                field: 'locationAddress',
            },
            {
                headerName: 'City',
                enableValue: true,
                field: 'locationCity',
            },
            {
                headerName: 'State',
                enableValue: true,
                field: 'locationState',
            },
            {
                headerName: 'Zip',
                enableValue: true,
                field: 'locationZip',
            },
            {
                headerName: 'In-Force TIV',
                field: 'totalInsurableValue',
                valueFormatter: ({ value }: any) => (value ? formatDollar(value, 0) : ''),
                cellStyle: { textAlign: 'right' },
                comparator: numberSort,
                enableValue: true,
                aggFunc: 'sum',
                filter: 'agNumberColumnFilter',
            },
            {
                headerName: 'Bound Premium',
                field: 'boundPremium',
                valueFormatter: ({ value }: any) => (value ? formatDollar(value, 0) : ''),
                cellStyle: { textAlign: 'right' },
                comparator: numberSort,
                enableValue: true,
                aggFunc: 'sum',
                filter: 'agNumberColumnFilter',
            },
            {
                headerName: '% of Bound',
                field: 'tivPer',
                aggFunc: 'sum',
                valueFormatter: ({ value }: any) => formatPercent(value, 0),
                comparator: numberSort,
                filter: 'agNumberColumnFilter',
            },
            {
                headerName: 'Quoted TIV',
                field: 'totalQuotedTIV',
                valueFormatter: ({ value }: any) => (value ? formatDollar(value, 0) : ''),
                cellStyle: { textAlign: 'right' },
                comparator: numberSort,
                enableValue: true,
                aggFunc: 'sum',
                filter: 'agNumberColumnFilter',
            },
            {
                headerName: 'Quoted Premium',
                field: 'quotedPremium',
                valueFormatter: ({ value }: any) => (value ? formatDollar(value, 0) : ''),
                cellStyle: { textAlign: 'right' },
                comparator: numberSort,
                enableValue: true,
                aggFunc: 'sum',
                filter: 'agNumberColumnFilter',
            },
            {
                headerName: 'Effective Date',
                field: 'effectiveDate',
            },
            {
                headerName: 'Submission State',
                field: 'statusStage',
                filter: true,
                hide: true,
            },
        ],
        autoGroupColumnDef: {
            enableValue: false,
            minWidth: 200,
            filter: 'agSetColumnFilter',
            textAlign: 'left',
        },
    },
    overrides: {
        zipcode: {
            columnDefs: [
                {
                    headerName: 'Location Zip',
                    field: 'locationZip',
                },
            ],
            autoGroupColumnDef: {
                headerName: 'Location Zip',
                filterValueGetter: (params: ValueGetterParams) => {
                    return params.data.locationZip;
                },
            },
        },
        state: {
            columnDefs: [
                {
                    headerName: 'Location State',
                    field: 'locationState',
                },
            ],
            autoGroupColumnDef: {
                headerName: 'Location State',
                filterValueGetter: (params: ValueGetterParams) => {
                    return params.data.locationState;
                },
            },
        },
        zone: {
            columnDefs: [
                {
                    headerName: 'Location Zone',
                    field: 'locationZone',
                },
            ],
            autoGroupColumnDef: {
                headerName: 'Zone',
                filterValueGetter: (params: ValueGetterParams) => {
                    return params.data.locationZone;
                },
            },
        },
        zone_group: {
            columnDefs: [
                {
                    headerName: 'Zone Group',
                    field: 'locationZoneGroup',
                },
            ],
            autoGroupColumnDef: {
                headerName: 'Region',
                filterValueGetter: (params: ValueGetterParams) => {
                    return params.data.locationZoneGroup;
                },
            },
        },
    },
});
